import React from 'react'

import { useLuminaireDownlinkRssi } from '../../../hooks/useLuminaireMetrics'
import ProfessionalChartLoader from '../../../../../common/components/molecule/Chart/ChartLoaderView/ProfessionalChartLoader'
import ChartErrorView from '../../../../../common/components/molecule/Chart/ChartLoaderView/ChartErrorView'
import { createList } from '../../../../../common/utils/graph.utils'
import { formatDateByPeriod } from '../../../../../common/utils/dateFormatter'
import ChartLineView from '../../../../../common/components/molecule/Chart/ChartLineView/ChartLineView'
import { LuminaireMetricFilter } from '../../../types/luminaire.types'
import { AggregateWindow } from '../../../../../features/filter/types/types'

interface Props {
  devEui: string
  filter: LuminaireMetricFilter
}

export default function LuminaireDownlinkRssiChartPresenter({ devEui, filter }: Props) {
  const { downlinkRssiQuery: query } = useLuminaireDownlinkRssi(devEui, filter)

  if (query.isLoading) {
    return <ProfessionalChartLoader metricName="RSSI downlink" />
  }

  if (query.isError) {
    return <ChartErrorView metricName="RSSI downlink" />
  }

  const aggWindow = (filter.aggregateWindow || '1h') as AggregateWindow
  const filterPoint = {
    startDate: filter.startDate,
    stopDate: filter.stopDate,
    aggregateWindow: aggWindow,
  }
  const dataChart = createList(aggWindow, filterPoint, query.data)

  return (
    <ChartLineView
      xAxisData={dataChart.listx.map((item) =>
        formatDateByPeriod(item, aggWindow)
      )}
      data={dataChart.listValue}
      label="RSSI downlink (dBm)"
      unit="dBm"
    />
  )
}
